const FYGR_COMPANY = 'FYGR_COMPANY';

// Every accounting endpoint is prefixed with `company/<company_id>/accounting`.
export const companyId = () => localStorage.getItem(FYGR_COMPANY);
export const base = () => `company/${companyId()}/accounting`;
